module.exports = __webpack_public_path__ + "static/media/property-manager2.9e24ca03.jpg";